import { Converter } from '../types/converter';

export const electricResistanceConverter: Converter = {
  id: 'electricResistance',
  name: 'Electric Resistance Converter',
  icon: 'Zap',
  categories: ['electricity'],
  units: [
    // Base SI unit
    { name: 'Ohm', symbol: 'Ω', factor: 1 },
    { name: 'Megohm', symbol: 'MΩ', factor: 1e6 },
    { name: 'Microhm', symbol: 'µΩ', factor: 1e-6 },
    
    // Alternative expressions
    { name: 'Volt/ampere', symbol: 'V/A', factor: 1 },
    { name: 'Reciprocal siemens', symbol: '1/S', factor: 1 },
    
    // CGS units
    { name: 'Abohm', symbol: 'abΩ', factor: 1e-9 },
    { name: 'EMU of resistance', symbol: 'EMU', factor: 1e-9 },
    { name: 'Statohm', symbol: 'stΩ', factor: 8.987552e11 },
    { name: 'ESU of resistance', symbol: 'ESU', factor: 8.987552e11 },
    
    // Quantum unit
    { name: 'Quantized Hall resistance', symbol: 'RH', factor: 25812.807 }
  ]
};
